import { useQuery } from '@tanstack/react-query'
import { secureFetch } from '@/utils/SecureFetch'
import { usePlaybookLabels, playbookLabelKeys } from '@/hooks/UsePlaybookLabels'
import { PlaybookLabelsPanel } from '@/components/playbook-settings/PlaybookLabelsPanel'
import './settings-section.css'

interface LabelsSectionProps {
	playbookId: string
}

export function LabelsSection({ playbookId }: LabelsSectionProps) {
	const {
		labels,
		createLabel,
		updateLabel,
		deleteLabel,
		reorderLabels,
	} = usePlaybookLabels(playbookId)

	const { data: usageCounts = [] } = useQuery({
		queryKey: playbookLabelKeys.counts(playbookId),
		queryFn: async () => {
			const res = await secureFetch(`/api/playbooks/${playbookId}/labels/counts`)
			if (!res.ok) throw new Error('Failed to fetch label counts')
			return (await res.json()).counts as Array<{
				label_id: string
				play_count: number
				formation_count: number
				concept_count: number
			}>
		},
		enabled: !!playbookId,
	})

	return (
		<div className="settings-section">
			<h3 className="settings-section-title">Labels</h3>
			<p className="settings-description">
				Organize plays, formations, and concepts with labels
			</p>
			<PlaybookLabelsPanel
				labels={labels}
				usageCounts={usageCounts}
				onUpdateLabel={async (data) => { await updateLabel(data) }}
				onDeleteLabel={async (id) => { await deleteLabel(id) }}
				onReorder={async (ids) => { await reorderLabels(ids) }}
				onCreateLabel={async (data) => { await createLabel(data) }}
			/>
		</div>
	)
}
